import getColor, { getButtonColor, getButtonHover } from "@nishtech/MobiusOverrides/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import resolveColor from "@insite/mobius/utilities/resolveColor";

export interface NishtechStyle {
    cssOverride: InjectableCss;
}

export const nishtechStyles: NishtechStyle = {
    cssOverride: {
        css: css`
            address p {
                margin-bottom: 0px;
            }
            /* Custom Nishtech CSS Stylings*/
            .as-nav-active {
                .as-nav-opener {
                    &:after {
                        top: 9px;
                        top: 9px;
                        transform: rotate(-45deg);
                    }

                    &:before {
                        top: 9px;
                        top: 9px;
                        transform: rotate(45deg);
                    }

                    span {
                        opacity: 0;
                    }
                }
            }

            .as-topbar-active {
                .as-nav-drop {
                    height: calc(var(--full-viewport) - 106px);
                    top: 112px;
                }
            }

            @media (min-width: 520px) {
                .as-topbar-active {
                    .as-nav-drop {
                        height: calc(var(--full-viewport) - 90px);
                        top: 96px;
                    }
                }
            }

            @media (max-width: 1023px) {
                .as-nav-active {
                    overflow: hidden;
                    .as-nav-drop {
                        transform: translateX(0);
                    }
                }
            }

            .as-wrapper {
                overflow: hidden;
                position: relative;
                width: 100%;
            }
            /* Add to cart popup styles start */

            svg {
                height: 100%;
                max-width: 100%;
                vertical-align: top;
            }
            .as-btn {
                display: inline-block;
                font-size: 16px;
                letter-spacing: 0.48px;
                line-height: 1.2;
                padding: 13px 23px;
                text-align: center;
                transition:
                    background 0.3s ease,
                    color 0.3s ease;
                vertical-align: top;
            }
            .as-btn-primary {
                background: ${p => resolveColor(p.theme?.button?.primary?.color, p.theme)};
                color: ${p =>
                    p.theme?.button?.primary?.typography?.color || p.theme?.button?.primary?.textColor || "#ffffff"};

                border: ${p => {
                    const type = p.theme?.button?.primary?.buttonType;
                    if (type === "outline") {
                        return `2px solid ${resolveColor(p.theme?.button?.primary?.color, p.theme)}`;
                    }
                    if (type === "ghost") {
                        return "none";
                    }
                    return `2px solid ${resolveColor(p.theme?.button?.primary?.color, p.theme)}`;
                }};

                border-radius: ${p => {
                    switch (p.theme?.button?.primary?.shape) {
                        case "rounded":
                            return "50px";
                        case "square":
                            return "0px";
                        case "pill":
                            return "9999px";
                        default:
                            return "10px";
                    }
                }};

                font-family: ${p => p.theme?.button?.primary?.typography?.fontFamily || "inherit"};
                font-size: ${p => p.theme?.button?.primary?.typography?.size || "inherit"};
                font-weight: ${p =>
                    p.theme?.button?.primary?.typography?.weight ||
                    p.theme?.button?.primary?.typographyProps?.weight ||
                    "normal"};
                line-height: ${p => p.theme?.button?.primary?.typography?.lineHeight || "normal"};
                letter-spacing: ${p => p.theme?.button?.primary?.typography?.letterSpacing || "normal"};
                text-transform: ${p => p.theme?.button?.primary?.typography?.textTransform || "none"};

                ${p => (p.theme?.button?.primary?.typography?.underline ? "text-decoration: underline;" : "")}
                ${p => (p.theme?.button?.primary?.typography?.italic ? "font-style: italic;" : "")}

    ${p => (p.theme?.button?.primary?.shadow ? "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);" : "")}

    ${p => {
                    const type = p.theme?.button?.primary?.buttonType;
                    const color =
                        p.theme?.button?.primary?.typography?.color || p.theme?.button?.primary?.textColor || "#ffffff";

                    if (type === "outline") {
                        return `
                background: transparent;
                color: ${color};
            `;
                    }

                    if (type === "ghost") {
                        return `
                background: transparent;
                color: ${color};
            `;
                    }

                    return "";
                }}

    ${p => p.theme?.button?.primary?.css}

    &:hover {
                    background: ${p =>
                        resolveColor(
                            p.theme?.button?.primary?.hoverBackgroundColor || p.theme?.button?.primary?.color,
                            p.theme,
                        )};
                    border-color: ${p =>
                        resolveColor(
                            p.theme?.button?.primary?.hoverBackgroundColor || p.theme?.button?.primary?.color,
                            p.theme,
                        )};
                    ${p => p.theme?.button?.primary?.hoverAnimation}
                }
            }

            .as-btn-outline {
                border: 1px solid ${getColor("primary.main")};
                border-radius: 10px;
                color: ${getColor("primary.main")};
                font-weight: 700;
                &:hover {
                    background-color: ${getColor("primary.main")};
                    color: #fff;
                }
            }
            .as-card-holder {
                background: #fff;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
                margin: 20px 0 0;
                padding: 22px 22px 14px;
                position: absolute;
                right: 0px;
                top: 100%;
                width: 100vw;
                .as-ttl {
                    color: #013d54;
                    display: block;
                    font-family: "Inter Tight", Arial;
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 1.2;
                    margin: 0 0 10px;
                    padding-right: 25px;
                }
                .as-close {
                    position: absolute;
                    right: 19px;
                    top: 17px;
                    &:hover {
                        svg {
                            line {
                                stroke: #c8102e;
                            }
                        }
                    }
                    svg {
                        line {
                            transition: stroke 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                        }
                    }
                }
                .as-product-holder {
                    display: flex;
                }
                .as-image {
                    border: 2px solid #e5e6e5;
                    height: 176px;
                    margin-right: 18px;
                    min-width: 176px;
                    width: 176px;
                    img {
                        height: 100%;
                        vertical-align: top;
                        width: 100%;
                    }
                }
                .as-text-area {
                    flex: 1 1 auto;
                    padding: 23px 0 0;
                    a {
                        &:hover {
                            color: #c8102e;
                        }
                    }
                }
                .as-subtitle {
                    color: #013d54;
                    display: block;
                    font-size: 14px;
                    font-weight: 350;
                    letter-spacing: 0.01em;
                    margin-top: -10px;
                }
                .as-product-ttl {
                    color: #013d54;
                    display: block;
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 0.15px;
                    line-height: 1.2;
                    margin: 0 0 29px;
                }
                .as-text {
                    display: block;
                    font-family: "Inter Tight", Arial;
                    font-size: 12px;
                    line-height: 1.2;
                    margin: 0 0 4px;
                }
                .as-wrap-btn {
                    padding-top: 22px;
                    .as-btn {
                        display: block;
                        flex-grow: 1;
                        margin: 0 0 11px;
                        padding: 13px 23px 11px;
                        text-align: center;
                    }
                }
            }

            @media (min-width: 768px) {
                .as-card-holder {
                    display: flex;
                    flex-direction: column;
                    min-height: 302px;
                    padding: 15px 23px 21px;
                    right: -20px;
                    width: 420px;
                    .as-ttl {
                        font-size: 23px;
                        margin: 0 0 17px;
                    }
                    .as-close {
                        right: 22px;
                        top: 19px;
                    }
                    .as-image {
                        height: 130px;
                        margin-right: 12px;
                        min-width: 130px;
                        width: 130px;
                    }
                    .as-text-area {
                        padding: 19px 0 0;
                    }
                    .as-product-ttl {
                        font-size: 15px;
                        margin: 0px;
                    }
                    .as-text {
                        font-size: 14px;
                        margin: 0 0 4px;
                    }
                    .as-wrap-btn {
                        display: flex;
                        justify-content: space-between;
                        margin: auto -8px 0;
                        padding-top: 25px;
                        .as-btn {
                            margin: 0 8px;
                        }
                    }
                }
            }
            @media (max-width: 1023px) {
                .as-card-holder {
                    .as-subtitle {
                        display: none;
                    }
                }
            }
            @media (max-width: 767px) {
                .as-card-holder {
                    .as-wrap-btn {
                        .as-btn {
                            border-radius: 20px;
                            border-width: 2px;
                            font-size: 20px;
                            letter-spacing: 0.6px;
                            padding: 17px 23px 16px;
                        }
                    }
                }
            }

            .as-cart-popup {
                .as-close {
                    position: absolute;
                    right: 0;
                    background: none;
                    top: 25px;
                    font-size: 10px;
                    svg {
                        line {
                            transition: stroke 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                        }
                    }
                    &:hover {
                        svg {
                            line {
                                stroke: #c8102e;
                            }
                        }
                    }
                }
            }

            @media (min-width: 768px) {
                .as-cart-popup {
                    .as-close {
                        right: -20px;
                        top: 25px;
                        font-size: 10px;
                    }
                }
            }
            .pf-breadcrumbs-wrapper {
                max-width: none;
                padding: 0;
            }
            .social-link {
                color: ${getColor("secondary.contrast")} !important;
            }
            .social-link:hover {
                color: ${getColor("secondary.main")} !important;
            }
            /* Add to cart popup styles end */

            .as-navigation .as-nav-opener.open::after {
                top: 0;
                transform: none;
            }
            .as-navigation .as-nav-opener.open::before {
                bottom: 0;
                top: auto;
                transform: none;
            }
            .as-navigation .as-nav-opener.open span {
                opacity: 1;
            }
            @media (max-width: 1024px) {
                .as-navigation .as-nav-drop.open {
                    top: 129px !important;
                }
            }
            @media (max-width: 1024px) {
                .as-nav-active .as-navigation .as-nav-drop {
                    top: 129px !important;
                }
            }
        `,
    },
};
